import axios from 'axios';
import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { get } from 'lodash';
import { trimUserInput } from 'utils/formHelpers';

import './style.css';

const validate = formProps => {
  const errors = {};

  if (!formProps.email) {
    errors.email = 'Required';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formProps.email)) {
    errors.email = 'Invalid email address';
  }

  return errors;
};

// TODO: pretty sure this renderField code is in many place, DRY
const renderField = ({
  input,
  label,
  type,
  disabled,
  meta: { touched, error, warning }
}) => {
  let hasStatus = null;
  let message = null;

  // remove touched from first two tests to
  // force form validation on initial load
  if (touched && error) {
    hasStatus = 'danger';
    message = error;
  } else if (touched && warning) {
    hasStatus = 'warning';
    message = warning;
  } else if (touched) {
    hasStatus = 'success';
    message = null;
  } else {
    hasStatus = null;
    message = null;
  }

  return (
    <div className={`form-group ${hasStatus ? 'has-' + hasStatus : ''}`}>
      <div className={`input-wrapper rounded  ${hasStatus ? 'has-' + hasStatus : ''}`}>
        <div className="text-left px-4">
          <small>{label}</small>
        </div>
        <input
          id={input.name}
          className="form-control form-control-danger form-control-warning form-control-success border-0 px-4"
          {...input}
          disabled={disabled}
          type={type}
        />
      </div>
      {message ? (
        <div className="form-control-feedback">
          <small>{message}</small>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

class TeacherOnBoard extends Component {
  handleFormSubmit = (values) => {
    // clean up any user input
    const userInput = trimUserInput(values);

    // pick off the values we want
    const { email } = userInput;

    return new Promise((resolve, reject) => {
      const data = {
        email
      };
      axios
        .post(`${process.env.REACT_APP_BACKEND_URL}/admin/teachers`, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.props.user.token}`
          }
        })
        .then(() => {
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    }).catch(ex => {
      if (process.env.NODE_ENV !== 'production') {
        console.log('catch', ex);
      }
      const response = get(ex, 'response.data');
      // response may be an object with an unpredictable key. e.g. 'account.email', 'message'
      const message = response ? JSON.stringify(response) : ex.message;
      throw new SubmissionError({ _error: message });
    });
  }

  render() {
    const {
      error, handleSubmit, pristine, submitting, submitSucceeded
    } = this.props;
    return (
      <div className="TeacherOnboard">
        <h4 className="mb-4">Invite Teacher To Rype</h4>
        <form className="HelpForm form" onSubmit={handleSubmit(this.handleFormSubmit)}>
          {submitSucceeded && <p>We&#39;ve have sent an invite link to the email provided</p>}
          {error && <p className="text-danger my-2">{error}</p>}
          <Field
            name="email"
            component={renderField}
            type="email"
            label="Email"
            placeholder="Email"
          />
          <button
            disabled={submitting || pristine}
            type="submit"
            className="btn btn-primary btn-lg btn-blue btn-cursor btn-teacher-dashboard"
          >
            Invite
          </button>
        </form>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user
  };
}

export default compose(
  connect(mapStateToProps, {}),
  reduxForm({ form: 'adminInviteTeacherForm', validate })
)(TeacherOnBoard);



// WEBPACK FOOTER //
// ./src/pages/admin/routes/TeacherOnboard/index.js